export const toggleBodyFixed = (value) => {
    if (typeof value == 'boolean') {
        if (value) {
            document.body.classList.add('hidden');

            return true;
        }

        document.body.classList.remove('hidden');

        return false;
    }
    if (document.body.classList.contains('hidden')) {
        document.body.classList.remove('hidden');

        return false;
    }

    document.body.classList.add('hidden');

    return true;
}

export const setThemeClass = (theme) => {
    if (!document.body.classList.contains(theme)) {
        document.body.className = theme;
    }
    return true;
}

export const getFloorplanBackgroundImage = (floorplanImagesPath, floorplanStages) => {
    if (floorplanImagesPath && floorplanStages.length) {
        return floorplanImagesPath + floorplanStages[0].stageImage;
    }

    return null;
}

export const isChrome = () => {
    const isChromium = window.chrome,
        winNav = window.navigator,
        vendorName = winNav.vendor,
        isOpera = winNav.userAgent.indexOf('OPR') > -1,
        isIEedge = winNav.userAgent.indexOf('Edge') > -1,
        isIOSChrome = winNav.userAgent.match('CriOS');

    if (isIOSChrome) {
        return true;
    } else if (isChromium !== null
        && typeof isChromium !== 'undefined'
        && vendorName === 'Google Inc.'
        && isOpera === false
        && isIEedge === false
    ) {
        return true;
    }
    return false;
}

export const isIE = (getVersion) => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');
    const edge = ua.indexOf('Edge/');

    let version = '';

    if (msie > 0) {
        version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    if (trident > 0) {
        const rv = ua.indexOf('rv:');
        version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    if (edge > 0) {
        version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    if (getVersion) {
        return version;
    }

    return !!+version;
}

export const isAndroid = () => navigator.userAgent && navigator.userAgent.match('Android');

export const isSafari = () => navigator.vendor && navigator.vendor.indexOf('Apple') > -1
    && navigator.userAgent && !navigator.userAgent.match('CriOS');

export const isFirefox = () => navigator.userAgent
    && navigator.userAgent.toLowerCase().indexOf('firefox') > -1
    && navigator.userAgent.toLowerCase().indexOf('eamonkey') === -1;

export const getWindowScrollTop = () => {
    const supportPageOffset = window.pageXOffset !== undefined;
    const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');

    return supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
            ? document.documentElement.scrollTop
            : document.body.scrollTop;
}

export const getOffsetRect = (elem) => {
    const box = elem.getBoundingClientRect();
    const body = document.body;
    const docElem = document.documentElement;
    const clientTop = docElem.clientTop || body.clientTop || 0;
    const scrollTop = getWindowScrollTop();
    const scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
    const clientLeft = docElem.clientLeft || body.clientLeft || 0;
    const top  = box.top +  scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;

    return {
        top: Math.round(top),
        left: Math.round(left)
    }
}

export const isFullScreenAvailable = () => {
    if (document.documentElement.requestFullScreen
        || document.documentElement.msRequestFullscreen
        || document.documentElement.mozRequestFullScreen
        || document.documentElement.webkitRequestFullScreen) {
            return true;
        }
        return false;
}

export const isTouchDevice = () => {
    if ((('ontouchstart' in window)
        || navigator.maxTouchPoints > 0
        || navigator.msMaxTouchPoints > 0)) {
            return true;
    }
    return false
}

const currencyOptions = {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
};

export const currencyFormat = new Intl.NumberFormat('en-US', currencyOptions);
export const numberFormat = new Intl.NumberFormat('en-US');
